import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close-sm",
  "use": "close-sm-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"close-sm\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m5.283 4.717 10 10-.566.566-10-10 .566-.566Z\" clip-rule=\"evenodd\" /><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m15.283 5.283-10 10-.566-.566 10-10 .566.566Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol